export default __webpack_public_path__ + "static/media/pop-grey.88053912.svg";